import React from 'react';

export const AudioVideoIcon = ({ size = 48, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="12" width="48" height="32" rx="3" stroke={color} strokeWidth="2.5" fill="none"/>
    <rect x="4" y="44" width="56" height="6" rx="2" stroke={color} strokeWidth="2.5" fill="none"/>
    <circle cx="20" cy="28" r="6" stroke={color} strokeWidth="2.5" fill="none"/>
    <circle cx="20" cy="28" r="2" fill={color}/>
    <path d="M36 24L36 32" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M40 22L40 34" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M44 26L44 30" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M48 24L48 32" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export const CCTVIcon = ({ size = 48, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 20H36C38 20 40 22 40 24V40C40 42 38 44 36 44H8C6 44 4 42 4 40V24C4 22 6 20 8 20Z" stroke={color} strokeWidth="2.5" fill="none"/>
    <path d="M40 28L52 20V44L40 36" stroke={color} strokeWidth="2.5" fill="none" strokeLinejoin="round"/>
    <circle cx="22" cy="32" r="8" stroke={color} strokeWidth="2.5" fill="none"/>
    <circle cx="22" cy="32" r="3" fill={color}/>
    <path d="M56 16L60 12" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M56 16V24" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="56" cy="16" r="2" fill={color}/>
  </svg>
);

export const AutomationIcon = ({ size = 48, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 52V28C12 16 20 8 32 8C44 8 52 16 52 28V52" stroke={color} strokeWidth="2.5" fill="none"/>
    <path d="M8 52H56" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <rect x="20" y="32" width="10" height="12" rx="1" stroke={color} strokeWidth="2.5" fill="none"/>
    <rect x="34" y="32" width="10" height="12" rx="1" stroke={color} strokeWidth="2.5" fill="none"/>
    <path d="M25 32V28" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M39 32V28" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="32" cy="20" r="4" stroke={color} strokeWidth="2.5" fill="none"/>
    <path d="M32 24V28" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="25" cy="38" r="2" fill={color}/>
    <circle cx="39" cy="38" r="2" fill={color}/>
  </svg>
);

export const SoftwareIcon = ({ size = 48, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="48" height="36" rx="3" stroke={color} strokeWidth="2.5" fill="none"/>
    <path d="M8 16H56" stroke={color} strokeWidth="2.5"/>
    <circle cx="14" cy="12" r="1.5" fill={color}/>
    <circle cx="20" cy="12" r="1.5" fill={color}/>
    <circle cx="26" cy="12" r="1.5" fill={color}/>
    <path d="M20 28L28 32L20 36" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M34 36H44" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M24 52H40" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M32 44V52" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export const PhoneIcon = ({ size = 20, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92V19.92C22 20.48 21.56 20.93 21 20.99C20.17 21.07 19.32 21.04 18.5 20.88C15.59 20.26 12.88 18.85 10.62 16.82C8.53 14.95 6.87 12.62 5.79 10.01C5.31 8.85 5.04 7.62 5 6.37C4.97 5.8 5.4 5.32 5.97 5.26L9 5C9.55 4.97 10.04 5.35 10.16 5.89L10.73 8.38C10.84 8.87 10.66 9.39 10.26 9.69L9.06 10.6C10.05 12.67 11.73 14.39 13.77 15.43L14.67 14.23C14.98 13.82 15.5 13.65 15.99 13.76L18.48 14.33C19.02 14.45 19.41 14.94 19.38 15.49L19.08 18.52C19.05 18.77 19.03 19.03 19.02 19.28L22 16.92Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const LocationIcon = ({ size = 24, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="9" r="3" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const EmailIcon = ({ size = 24, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="20" height="16" rx="2" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M2 6L12 13L22 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ClockIcon = ({ size = 24, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 6V12L16 14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CheckIcon = ({ size = 24, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill={color}/>
    <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ArrowRightIcon = ({ size = 16, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const QuoteIcon = ({ size = 32, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 8C10 10.21 8.21 12 6 12C5.27 12 4.57 11.81 4 11.5V16C4 17.1 4.9 18 6 18H10C11.1 18 12 17.1 12 16V10C12 7.79 10.21 6 8 6H6C4.9 6 4 6.9 4 8V8.5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 8C22 10.21 20.21 12 18 12C17.27 12 16.57 11.81 16 11.5V16C16 17.1 16.9 18 18 18H22C23.1 18 24 17.1 24 16V10C24 7.79 22.21 6 20 6H18C16.9 6 16 6.9 16 8V8.5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const StarIcon = ({ size = 20, filled = true, color = '#FF5722' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? color : 'none'} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FacebookIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export const InstagramIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

export const LinkedInIcon = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
